import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=4c7e8020&scoped=true"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"
import style0 from "./validation.vue?vue&type=style&index=0&id=4c7e8020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e8020",
  null
  
)

export default component.exports